import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/holiday-rules', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/holiday-rules', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getSubstitute = (options = {}) => {
  return httpClient
    .get('/api/holiday-rules/holiday-substitute', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { get, store, getSubstitute }
